import { useState, useEffect, useCallback } from 'react';
import { getTheme, applyTheme, toggleTheme, tokens, THEMES, label } from './theme';

export function useTheme() {
  const [theme, setThemeState] = useState(getTheme);

  useEffect(() => {
    const onChange = (e) => setThemeState(e.detail.theme);
    window.addEventListener('wof:theme', onChange);
    return () => window.removeEventListener('wof:theme', onChange);
  }, []);

  const setTheme = useCallback((k) => setThemeState(applyTheme(k)), []);
  const toggle = useCallback(() => setThemeState(toggleTheme()), []);

  return {
    theme,
    setTheme,
    toggle,
    isRoman: theme === 'roman',
    isNeon: theme === 'neon',
    meta: THEMES[theme],
    T: tokens(theme),
    L: (k) => label(k, theme),
  };
}

export default useTheme;